import React from 'react';
import { PropertyGroup } from './PropertyGroup';
import { ColumnWidthSelect } from '../PropertyInputs';

/**
 * Column width property component
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const ColumnWidthProperty = _ref => {
  let {
    field,
    updateField,
    selectedField
  } = _ref;
  return /*#__PURE__*/_jsx(PropertyGroup, {
    label: "Column Width",
    children: /*#__PURE__*/_jsx(ColumnWidthSelect, {
      value: field.columnWidth || '1',
      onChange: value => updateField(selectedField, {
        columnWidth: value
      })
    })
  });
};